import {PROTOCOLS_CSV} from '@/../configs/protocolsCsv';
import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import VpnForm from '@/components/Vpn/VpnForm/VpnForm';
import IVpn from '@/interfaces/vpns/IVpn';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component({
    name: 'VpnCreate',
    components: {
        Loader,
        CardHeader,
        VpnForm
    }
})
export default class VpnCreate extends Vue {
    @Action private createVpn!: (form: IVpn) => Promise<void>;

    private vpnData: IVpn = {
        ip: '',
        host: 'https://',
        active: false,
        privacyType: '',
        accessLevel: '',
        dataCenter: '',
        city: '',
        country: '',
        protocolsCsv: PROTOCOLS_CSV[0],
        alive: false,
        autoCreated: false
    };

    private isEdit: boolean = true;

    private loading: boolean = true;

    private vpnCreate(form: IVpn) {
        this.createVpn(form);
    }

    private mounted() {
        try {
            this.loading = false;
        } catch {
            return void 0;
        }
    }
}
